import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BoxList, FiltersControls, Pagination, Spinner, PrivateComponent } from 'components';
import {
  duplicateYcEventCreator,
  loadYcEventsCreator,
  setYcEventsPageCreator,
  setYcEventsPerPageCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';

const Completed = ({
  events,
  page,
  pages,
  perPage,
  loading,
  loadEvents,
  setPage,
  setPerPage,
  duplicateEvent,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    setPage(1);
  }, [perPage, setPage]);

  useEffect(() => {
    loadEvents({ status: 'completed' });
  }, [perPage, page, loadEvents]);

  return (
    <>
      <FiltersControls
        perPageSelected={perPage}
        perPageOnChange={({ value }) => setPerPage(value)}
      />
      {loading ? <Spinner /> : null}
      {!loading ? (
        <>
          <BoxList
            type="event"
            items={events}
            alert={t('global.noResultsFound')}
            customRenderActions={({ item, ButtonAction }) => (
              <>
                <PrivateComponent
                  permissions={{
                    roles: ['yc_events_create_event'],
                  }}
                >
                  <ButtonAction
                    icon="duplicate"
                    title={t('global.duplicateButton')}
                    verticalviewbreakpoint="xl"
                    onClick={() => duplicateEvent(item.id)}
                  />
                </PrivateComponent>
              </>
            )}
          />
          <Pagination styled currentPage={page} totalPages={pages} onChange={setPage} />
        </>
      ) : null}
    </>
  );
};

Completed.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  loadEvents: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  duplicateEvent: PropTypes.func.isRequired,
};

const mapStateToProps = ({ yc, loading }) => ({
  events: yc.events.list.items,
  page: yc.events.list.page,
  pages: yc.events.list.pages,
  perPage: yc.events.list.perPage,
  loading: isLoading(loading, 'YC'),
});
const mapDispatchToProps = (dispatch) => ({
  loadEvents: (payload) => dispatch(loadYcEventsCreator(payload)),
  setPage: (payload) => dispatch(setYcEventsPageCreator(payload)),
  setPerPage: (payload) => dispatch(setYcEventsPerPageCreator(payload)),
  duplicateEvent: (payload) => dispatch(duplicateYcEventCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Completed);
